import React, { memo } from "react";

const NameEdit = ({ value, row, closeModal }) => {
  const onClick = () => {
    const id = row["helper.id"];

    window.location = "#/Driver/edit/" + id;
    Monet.TabControl.selectTab("Driver");

    closeModal();
  };

  return (
    <div
      className="edit"
      onClick={onClick}>
      {value}
    </div>
  );
};

export default memo(NameEdit);
